export default "__VITE_ASSET__fGOY2fmm__"